import type { Project } from '@/types'
import Tag from '@/components/ui/Tag'
import ScrollReveal from '@/components/ui/ScrollReveal'
import VimeoEmbed from '@/components/ui/VimeoEmbed'

interface VodafoneHeroProps {
  project: Project
}

export default function VodafoneHero({ project }: VodafoneHeroProps) {
  return (
    <div>
      <ScrollReveal>
        <h1 className="text-display mb-6">Vodafone Motion System</h1>
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <VimeoEmbed videoId={project.previewVideoId} />
      </ScrollReveal>

      <ScrollReveal delay={0.15}>
        <div className="grid grid-cols-1 md:grid-cols-[400px_1fr] gap-8 md:gap-12 mt-8">
          <div className="flex flex-col gap-6">
            <div>
              <span className="text-label uppercase tracking-widest text-text-muted">Role</span>
              <p className="text-body text-text-primary mt-1">{project.role}</p>
            </div>
            <div>
              <span className="text-label uppercase tracking-widest text-text-muted">Date</span>
              <p className="text-body text-text-primary mt-1">{project.date}</p>
            </div>
            <div>
              <span className="text-label uppercase tracking-widest text-text-muted">Tags</span>
              <div className="flex flex-wrap gap-2 mt-2">
                <Tag label="Design Systems" />
                <Tag label="UX Choreography" />
                <Tag label="Developer Tokens" />
              </div>
            </div>
          </div>
          <p className="text-body text-text-secondary leading-relaxed">
            As Vodafone&apos;s first in-house Motion Designer, I encountered a fragmented digital
            ecosystem suffering from inconsistent, slow animations that hindered engineering delivery
            and confused users. I architected a scalable, physics-based motion framework from the
            ground up, translating kinetic principles into robust design tokens to unify the
            experience across web, iOS, and Android for millions of users.
          </p>
        </div>
      </ScrollReveal>
    </div>
  )
}
